import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import i18n from '@/plugins/i18n/index.js'

const validations = {}

validations.login = function ({ emailOrPhone, password, registerWithPhone }) {
  if (rules.required(emailOrPhone) !== true || typeof rules.required(emailOrPhone) === 'string') {
    notifications.error(i18n.t('rules.emailOrPhoneAreRequired'))
    return false
  }
  if (rules.required(password) !== true || typeof rules.required(password) === 'string') {
    notifications.error(i18n.t('rules.passwordIsRequired'))
    return false
  }
  if (registerWithPhone &&
      (rules.onlyNumbers(emailOrPhone) !== true ||
      typeof rules.onlyNumbers(emailOrPhone) === 'string')) {
    notifications.error(i18n.t('rules.onlyNumbers'))
    return false
  }
  if (!registerWithPhone &&
        (rules.email(emailOrPhone) !== true ||
            typeof rules.email(emailOrPhone) === 'string')) {
    notifications.error(i18n.t('rules.validEmail'))
    return false
  }
  if (rules.min8(password) !== true || typeof rules.min8(password) === 'string') {
    notifications.error(i18n.t('rules.passwordMin8'))
    return false
  }
  return true
}

validations.register = function (data) {
  if (rules.required(data.name) !== true || typeof rules.required(data.name) === 'string') {
    notifications.error(i18n.t('rules.nameIsRequired'))
    return false
  }

  if (!data.phone && (rules.required(data.email) !== true || typeof rules.required(data.email) === 'string')) {
    notifications.error(i18n.t('rules.emailOrPhoneAreRequired'))
    return false
  }

  if (!data.email && (rules.required(data.phone) !== true || typeof rules.required(data.phone) === 'string')) {
    notifications.error(i18n.t('rules.emailOrPhoneAreRequired'))
    return false
  }

  if (data.phone && (rules.onlyNumbers(data.phone) !== true || typeof rules.onlyNumbers(data.phone) === 'string')) {
    notifications.error(i18n.t('rules.onlyNumbers'))
    return false
  }

  if (rules.required(data.password) !== true || typeof rules.required(data.password) === 'string') {
    notifications.error(i18n.t('rules.passwordIsRequired'))
    return false
  }

  if (data.password && (rules.min8(data.password) !== true || typeof rules.min8(data.password) === 'string')) {
    notifications.error(i18n.t('rules.passwordMin8'))
    return false
  }
  if (!data.habeasData) {
    notifications.error(i18n.t('rules.habeasData'))
    return false
  }
  return true
}

validations.resetPassword = function ({ emailOrPhone, type }) {
  if (rules.required(emailOrPhone) !== true || typeof rules.required(emailOrPhone) === 'string') {
    notifications.error(i18n.t('rules.emailOrPhoneAreRequired'))
    return false
  }
  if (type === 'email') {
    if (!rules.email(emailOrPhone) || typeof rules.email(emailOrPhone) === 'string') {
      notifications.error(i18n.t('rules.validEmail'))
      return false
    }
  } else if (type === 'phone') {
    if (!rules.onlyNumbers(emailOrPhone) || typeof rules.onlyNumbers(emailOrPhone) === 'string') {
      notifications.error(i18n.t('rules.validPhone'))
      return false
    }
  }
  return true
}

validations.newPassword = function ({ code, password, rpassword }) {
  if (rules.required(code) !== true || typeof rules.required(code) === 'string') {
    notifications.error(i18n.t('rules.codeIsRequired'))
    return false
  }

  if (rules.required(password) !== true || typeof rules.required(password) === 'string') {
    notifications.error(i18n.t('rules.newPasswordIsRequired'))
    return false
  }

  if (rules.required(rpassword) !== true || typeof rules.required(rpassword) === 'string') {
    notifications.error(i18n.t('rules.confirmNewPassword'))
    return false
  }
  if (password !== rpassword) {
    notifications.error(i18n.t('rules.passwordsDontMatch'))
    return false
  }
  if (rules.min8(password) !== true || typeof rules.min8(password) === 'string') {
    notifications.error(i18n.t('rules.passwordMin8'))
    return false
  }
  return true
}

validations.minimumAmount = function (value, minimumAmount) {
  if (!rules.minimumAmount(value, minimumAmount)) {
    notifications.error(`El monto mínimo es de $${minimumAmount} USD`)
    return false
  }
  return true
}

export default validations
